import React from "react";
import { useGTMEvents, useGTM } from "hooks";
import { trackApiEvents } from "./trackApiEvents";
import { useCurrencyCode } from "hooks/useCurrencyCode";

type Props = {
  is404?: boolean;
  eventId?: string;
};

export const GTM: React.FC<Props> = ({ eventId, is404 = false }) => {
  useGTM(eventId, is404);
  useGTMEvents(is404);
  const currencyCode = useCurrencyCode();
  React.useEffect(() => {
    trackApiEvents(currencyCode);
  }, [currencyCode]);
  return null;
};
